import gql from 'graphql-tag'

export const GET_OPEN_POSITION_FOR_CLIENT = gql`
  query spGetCurrentPosition {
    spGetCurrentPosition
  }
`
